import React,{Suspense} from 'react';
import {
  ProductAuthenticationLog,
  ProtectedProfile,
  ProtectedAdmin,
  ProtectedUserList,
  ProtectedPrjectList,
  ProtectedDashboard,
  CreateUser,
  ProductedSettings,
  ProductedProductList,
  ProductedClientList,
  ProductedCreateCustomer,
  ProductedCreateProduct,
  ProductedCreateProject,
  ProductedBasicDeatils,
  ProductedProjectSummary,
  ProductedDefaultConfigs,
  ProductedUploadPdfFile,
  ProductdPdfviewer,
  UserHelperContent,
  ProductdProjectBase,
  ProductdProjectOverview,
  ProductProdductPrice,
  ProductConfigurationPresets,
  AddNewConfigurationPresets,
  ProductdProjectFiles,
  ProjectTakeOffStructureView,
  ProductdProjectStructure,
  ProductdProjectSubmittals,
  ProductdProjectSettings
} from '../optimisedRoutes/techus-lazyRoutes';
import ProtectedRoute from '../../utils/techus-ProtectedRouteUtils';
import UserLayout from '../../components/UserModule/UserLayout';
import Home from '../../components/UserModule/Home';
import { TopDivProvider } from '../../hooks/Topdiv';
import { SessionHandler } from '../../axois/SessionHandler';
import Loader from '../../genriccomponents/loaders/RedLoader';
const userRoutes = [
  {
    element: (
      <Suspense fallback={<Loader/>}>
      <ProtectedRoute>
         <SessionHandler />
        <UserLayout />
      </ProtectedRoute>
      </Suspense>
    ),
    children: [
      { path: '/dashboard', element: <ProtectedDashboard /> },
      { path: '/profile', element: <ProtectedProfile /> },
      { path: '/users', element: <ProtectedUserList /> },
      { path: '/projects', element: <ProtectedPrjectList /> },
      { path: '/users/add-user', element: <CreateUser /> },
      { path: '/products', element: <ProductedProductList /> },
      { path: '/products/add-product', element: <ProductedCreateProduct /> },
      { path: '/customers', element: <ProductedClientList /> },
      { path: '/customers/add-customer', element: <ProductedCreateCustomer /> },
      { path: '/projects/structure-extraction', element: <ProductdPdfviewer /> },
      { path: '/projects/structure-view', element: <ProjectTakeOffStructureView /> },
      {path: '/help', element: <UserHelperContent/>},
      { path: '/projects/add-project', 
        element: <ProductedCreateProject />,
      children:[
        {path: 'basic-details', element: <ProductedBasicDeatils />},
        {path: 'upload-pdfs', element: <ProductedUploadPdfFile />},
        {path: 'default-config', element: <ProductedDefaultConfigs />},
        {path: 'project-summary', element: <ProductedProjectSummary />},
       
      ] },
      { path: '/projects/edit-project', 
        element: <ProductedCreateProject />,
      children:[
        {path: 'basic-details', element: <ProductedBasicDeatils />},
        {path: 'upload-pdfs', element: <ProductedUploadPdfFile />},
        {path: 'default-config', element: <ProductedDefaultConfigs />},
        {path: 'project-summary', element: <ProductedProjectSummary />},
       
      ] },
      {
        path: '/projects/project-view', 
        element: <ProductdProjectBase />,
      children:[
        {path: 'overview', element: <ProductdProjectOverview />},
        {path: 'files', element: <ProductdProjectFiles />},
        
        {path: 'strcuture', element: <ProductdProjectStructure />},
        {path: 'submitals', element: <ProductdProjectSubmittals />},
        {path: 'settings', element: <ProductdProjectSettings />},
      ] },
      
      {
        path: '/settings',
        element: <ProductedSettings />,
        children: [
          { path: 'authentication-log', element: <ProductAuthenticationLog /> },
          { path: 'product-price', element: <ProductProdductPrice /> },
          { path: 'configuration-presets', element: <ProductConfigurationPresets /> },
        ],
      },
      { path: '/settings/add-presets', element: <AddNewConfigurationPresets /> },
      { path: '/settings/edit-presets', element: <AddNewConfigurationPresets /> },
    ],
  },
];

export default userRoutes;
